import React, { FC } from 'react';
import { Link } from 'react-router-dom';





interface FooterProps {
   
  }
  
  const Footer: FC<FooterProps> = () => (
    <div className="Footer-container">
        <footer className="pds-superFooter ">
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="pds-superFooter-logo">
            <a data-gtm="navigation-footer" className="pds-link-unstyled" href="https://www.principal.com" aria-label="Principal Homepage">
              <img className="pds-imgColorLogo" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="pds-superFooter-desktop container">
      <div className="row">
        <div className="col-5 col-lg-3">
          <p className="pds-superFooter-label" id="our-company">Our company</p>
          <nav aria-labelledby="our-company">
            <ul className="pds-superFooter-links">
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">About us</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">Investor relations</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">News room</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">Sustainability</a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="col-5 col-lg-3">
          <p className="pds-superFooter-label" id="we're-hiring">We're hiring</p>
          <nav aria-labelledby="we're-hiring">
            <ul className="pds-superFooter-links">
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">Careers</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">Global jobs</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">Financial professional opportunities</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">Internships</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">Recent graduates</a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="col-5 col-lg-3">
          <p className="pds-superFooter-label" id="other-sites">Other sites</p>
          <nav aria-labelledby="other-sites">
            <ul className="pds-superFooter-links">
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">For dental providers</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">For financial professionals</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">For institutional investors</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">Principal funds</a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="col-5 col-lg-3">
          <p className="pds-superFooter-label" id="fourth-column">Fourth column</p>
          <nav aria-labelledby="fourth-column">
            <ul className="pds-superFooter-links">
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">For dental providers</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">For financial professionals</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">For institutional investors</a>
              </li>
              <li>
                <a href='' role="link" data-gtm="call-to-action-toc">Principal funds</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <div className="pds-superFooter-mobile container">
      <div className="pds-collapsible">
        <details className="pds-collapsible-details">
          <summary className="pds-collapsible-summary" id="our-company-mobile" data-gtm="call-to-action-text">Our company</summary>
          <div className="pds-collapsible-details-text">
            <nav aria-labelledby="our-company-mobile">
              <ul className="pds-superFooter-links">
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">About us</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">Investor relations</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">News room</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">Sustainability</a>
                </li>
              </ul>
            </nav>
          </div>
        </details>
        <details className="pds-collapsible-details">
          <summary className="pds-collapsible-summary" id="we're-hiring-mobile" data-gtm="call-to-action-text">We're hiring</summary>
          <div className="pds-collapsible-details-text">
            <nav aria-labelledby="we're-hiring-mobile">
              <ul className="pds-superFooter-links">
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">Careers</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">Global jobs</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">Financial professional opportunities</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">Internships</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">Recent graduates</a>
                </li>
              </ul>
            </nav>
          </div>
        </details>
        <details className="pds-collapsible-details">
          <summary className="pds-collapsible-summary" id="other-sites-mobile" data-gtm="call-to-action-text">Other sites</summary>
          <div className="pds-collapsible-details-text">
            <nav aria-labelledby="other-sites-mobile">
              <ul className="pds-superFooter-links">
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">For dental providers</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">For financial professionals</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">For institutional investors</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">Principal funds</a>
                </li>
              </ul>
            </nav>
          </div>
        </details>
        <details className="pds-collapsible-details">
          <summary className="pds-collapsible-summary" id="fourth-column-mobile" data-gtm="call-to-action-text">Fourth column</summary>
          <div className="pds-collapsible-details-text">
            <nav aria-labelledby="fourth-column-mobile">
              <ul className="pds-superFooter-links">
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">For dental providers</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">For financial professionals</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">For institutional investors</a>
                </li>
                <li>
                  <a href='' role="link" data-gtm="call-to-action-toc">Principal funds</a>
                </li>
              </ul>
            </nav>
          </div>
        </details>
      </div>
    </div>
    <div className="pds-enterpriseFooter" data-settings-social="true" data-settings-espanol="false" />
  </footer>
    </div>
  );
  
  export default Footer;